import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
  name: 'userDeviceState',
  initialState: {
    deviceState : {}
  },
  reducers: {
    addState(state, action) {
      state.deviceState = action.payload;
    },
  },
});

export { actions as userDeviceStateActions };
export { reducer as userDeviceStateReducer };